import * as constants from '../constants';

const initialState = {
  comment: {
    input: {},
  },
  commentBy: {},
  email: '',
  hide_photo_upload: false,
  href: '',
  invite: {},
  languages: {},
  level: '',
  logo: '',
  program: {},
  user: {},
};

export function comment(state = initialState, action) {
  switch (action.type) {
    case constants.UPDATE_COMMENT_INFO:
      return action.comment;
    default:
      return state;
  }
}

const tempCommentInitialState = {
  comment: '',
  name: '',
  email: '',
  doubleByteExists: false,
  emojiExists: false,
};

// XML 1.0 defines certain characters as illegal, see https://www.w3.org/TR/REC-xml/
// this will only strip the control characters (< \x20). There are additional illegal characters,
// but these are the ones we've had trouble with

const NOT_SAFE_IN_XML_1_0 = /[\x00-\x08\x0B\x0C\x0E-\x1F]/gm; //eslint-disable-line
function sanitizeStringForXML(theString) {
  return theString.replace(NOT_SAFE_IN_XML_1_0, '');
}

// Function that removes all emoji from the string
function stripEmoji(str) {
    const strVal = str;
    const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff]|[\ufe00-\ufe0f])/g;
    // Regex information found at https://medium.com/reactnative/emojis-in-javascript-f693d0eb79fb
    const result = strVal.replace(regex, '');
    return result;
}

export function isDoubleByteExists(data) {
    let result = false;
    let str = data;
    str = stripEmoji(str.toString()); // emoji is removed so as to not influence result
    // The following ranges are for Basic Latin, Latin-1 Supplement, Latin Extended-A, and General Punctuation unicode blocks; also Trademark symbol
    const regex = /[\u0000-\u007F]|[\u0080-\u00FF]|[\u2000-\u206F]|[\u0100-\u017F]|\u2122/g; /* eslint-disable-line no-control-regex */
    const nonLatinCharacters = str.replace(regex, '');
    if (nonLatinCharacters.length > 0) {
        result = true;
    }
    return result;
}

export function isEmojiExists(data) {
  let result = false;
  const str = data;
  const ranges = [
    '(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])' /* eslint-disable-line no-control-regex */
  ];
  if (str.toString().match(ranges.join('|'))) {
     result = true;
  }
  return result;
}

function blankToEmptyString(str) {
  return /\S/.test(str) ? str : '';
}

export function tempComment(state = tempCommentInitialState, action) {
  switch (action.type) {
    case constants.ADD_USER_COMMENT:
      return Object.assign({}, state, {
        comment: sanitizeStringForXML(blankToEmptyString(action.comment)),
        doubleByteExists: isDoubleByteExists(action.comment),
        emojiExists: isEmojiExists(action.comment),
      });
    case constants.ADD_COMMENT_UTM_SOURCE:
      return Object.assign({}, state, {
        utm_source: action.utmSource
      });
    case constants.ADD_USER_NAME:
      return Object.assign({}, state, {
        name: sanitizeStringForXML(blankToEmptyString(action.name)),
      });
    case constants.ADD_USER_EMAIL:
      return Object.assign({}, state, {
        email: action.email,
      });
    default:
      return state;
  }
}

export function previewToggle(state = false, action) {
  switch (action.type) {
    case constants.TOGGLE_PREVIEW:
      return action.toggle;
    default:
      return state;
  }
}

export function imageLoading(state = -1, action) {
  switch (action.type) {
    case constants.TOGGLE_IMAGE_LOADING:
      return action.imageNumber;
    default:
      return state;
  }
}

export function uploadedImages(
  state = [undefined, undefined, undefined],
  action,
) {
  switch (action.type) {
    case constants.ADD_UPLOADED_PHOTO:
      return [
        ...state.slice(0, action.index),
        action.uploadedImageObject,
        ...state.slice(action.index + 1),
      ];
    case constants.DELETE_UPLOADED_PHOTO:
      return [
        ...state.slice(0, action.index),
        undefined,
        ...state.slice(action.index + 1),
      ];
    default:
      return state;
  }
}

export function displayFinalMessage(state = false, action) {
  switch (action.type) {
    case constants.TOGGLE_DISPLAY_FINAL_MESSAGE:
      return action.toggle;
    default:
      return state;
  }
}

export function commentsInfoReceived(state = false, action) {
  switch (action.type) {
    case constants.TOGGLE_COMMENTS_INFO_RECEIVED:
      return action.toggle;
    default:
      return state;
  }
}
